import {Group as LayerGroup} from 'ol/layer';

import { Layer } from './layer';

export class GroupLayer extends Layer {

    layers: Layer[];
    themes: string[]
    constructor(
        id: string,
        label: string,
        type: string,
        layers: Layer[],
        themes?: string[],
        hasLegend?: boolean,
    ) {
        super(id, label, type);
        this.layers = layers;
        if (themes) {
            this.themes = themes;
        }
        if (hasLegend) {
            this.hasLegend = hasLegend;
          }
    }

    toOlLayer() {
        const subLayers = this.layers.map( layer => layer.toOlLayer());
        //console.dir(subLayers);
        
        let layergroup =new LayerGroup({
            layers: subLayers
        });
        layergroup.set('customId', this.id)
        return layergroup;
    }
}